var _defs, _defs2, _defs3, _defs4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M163.6 164.2h1672.8V1837H163.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: 1000,
    cy: 1000.6,
    r: 836.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#d)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.6 164.2h1672.8V1837H163.6V164.2z",
    style: {
      fill: "#fec112"
    }
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M15.6 16.1h1969v1969H15.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#f)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 16.1c-543.2 0-984.4 441.3-984.4 984.4 0 543.1 441.3 984.4 984.4 984.4 543.1 0 984.4-441.3 984.4-984.4 0-543.1-441.3-984.4-984.4-984.4zm0 42.8c520.6 0 941.6 421 941.6 941.6s-421 941.6-941.6 941.6-941.6-421-941.6-941.6c0-520.5 421-941.6 941.6-941.6z",
    style: {
      fill: "#f7931f"
    }
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M448.4 536.2h1103V1464h-1103z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#h)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 1463.8c-103.8 0-235-16.5-267.9-20.8v-343.4c24.2-3.8 158.5-23.8 274.9-23.8 114.8 0 222.8 17.1 254.7 22.6v345.4c-40.7 5.2-162.5 20-261.7 20zm551.4-639.9c-23.3 22.1-67.9 64.5-115.7 109.5-76.6 72.2-139.8 156.5-140.5 157.3l-9.1 12.2h-.1v331.5c28.6-20.8 109-80.1 137.3-110.4 56.3-60.5 128.1-143.2 128.1-143.2V823.9zm-843.6 271.4h.7l-3.2-4.1c-.8-1-77-96.7-139.1-156.2-48.5-46.3-94-89.3-117.5-111.4v357.1s73.5 84.8 126.7 141.9c26.7 28.7 99.6 83.1 132.4 107.2v-334.5zm765.2-305c0 47.4-21.6 91.9-59.5 130.6 1.8-1.7 3.6-3.5 5.4-5.2 70-66 132.4-125.4 132.4-125.4s-93.2-88.3-137.4-130.2c37.7 38.6 59.1 83 59.1 130.2zm-313.7-253.5c95.5 19.5 176.8 56 232.7 103-38.6-34.1-116.4-95.3-116.4-95.3s-53.7-3.8-116.3-7.7zm-541.2 94.8c56.1-43.6 134.7-77.3 225.9-95.5-63.1 4.1-119.8 8.4-119.8 8.4s-62.5 49.9-106.1 87.1zm784.7 299.7c-67.7 62.5-179.1 108.1-309.7 123 102.6 6.5 182.5 21.9 182.5 21.9s55.6-74.5 127.2-144.9zm-809.4-3.6c61.8 61.3 130.9 148.4 130.9 148.4s88.2-14.4 188.5-21.3c-135.7-14.4-251.1-61.9-319.4-127.1zm-50.2-137.4c0-139.5 204.9-253 456.8-253s456.8 113.5 456.8 253-204.9 253-456.8 253-456.8-113.5-456.8-253zm117.9-12.5c0 105.9 148.8 188.9 338.9 188.9s338.9-83 338.9-188.9-148.9-189-338.9-189-338.9 83-338.9 189zm-212.5 12.5s63.7 59.6 134.3 127.2c1.5 1.4 3 2.9 4.5 4.3C548.9 882.9 527 838 527 790.3c0-47.2 21.5-91.6 59.1-130.2-36.7 34.7-137.5 130.2-137.5 130.2zm865.9-12.5c0-39.4-26.5-75.6-70.7-104 44 51.4 59.3 114.7 63.7 138.5 4.6-11.2 7-22.7 7-34.5zm-629 0c0 8.8 1.3 17.4 3.9 25.8 17-24.9 44-47.5 79.9-66.2 61.9-32.4 143.9-50.2 230.8-50.2 86 0 164.9 17.9 222.2 50.5 27.1 15.4 48.5 33.6 63.9 53.6-11-40.2-38-107.9-100.2-146.2-52.1-20-116.3-31.8-185.9-31.8-173.8-.1-314.6 73.5-314.6 164.5zm314.5-74.5c-144.5 0-266.2 50.8-303.7 120.1 6.6 12.2 15.7 23.7 27.1 34.6 13.1-10.7 28.4-20.8 45.9-29.9 61.9-32.4 143.9-50.2 230.8-50.2s168.8 17.8 230.8 50.2c17.5 9.1 32.7 19.2 45.9 29.9 6.2-5.9 11.8-12.1 16.6-18.4-23.2-77.5-137.9-136.3-293.4-136.3zm0 90.8c-110.5 0-207.7 29.8-264.1 74.8 17.2 13.8 38.3 26.1 62.3 36.6 57.5-23.8 127.8-36.8 201.8-36.8s144.3 13 201.8 36.8c24.1-10.5 45.1-22.8 62.3-36.6-56.4-45.1-153.6-74.8-264.1-74.8zm179.6 120.1c-51-18.5-112.9-29.4-179.6-29.4s-128.6 10.9-179.6 29.4c51 18.5 112.9 29.4 179.6 29.4s128.6-10.9 179.6-29.4z",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNet);
export default __webpack_public_path__ + "static/media/net.830f9eb94e881953aa02656b1739e191.svg";
export { ForwardRef as ReactComponent };